var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C7 18.1047 8.11917 19 9.5 19C10.8808 19 12 18.1047 12 17H7Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9.74071V8.67278C14.75 5.69144 12.5352 3.09201 9.66125 3.00256C6.68825 2.90922 4.25 5.3811 4.25 8.44411V9.74071C4.25 10.9191 3.88175 12.0648 3.2 13.0075L2.3375 14.1999C2.1185 14.5025 2 14.8711 2 15.2499C2 16.2167 2.75525 17 3.6875 17H15.3125C16.2448 17 17 16.2167 17 15.2499C17 14.8711 16.8815 14.5025 16.6625 14.1999L15.8 13.0075C15.1182 12.0648 14.75 10.9183 14.75 9.74071Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.2f65d648f412b4c40bf920137bb9ed8c.svg";
export { ForwardRef as ReactComponent };